// HELM type vocabulary is owned by `@datagrok-libraries/hwe` (the standalone
// HELM editor) and re-exported here as the single source of truth. The string
// values match the canonical Pistoia HELM Web Editor, except `NUCLEOTIDE` which
// uses the corrected spelling `HELM_NUCLEOTIDE` (was `HELM_NUCLETIDE`).
import { HelmTypes, MonomerTypes, PolymerTypes } from '@datagrok-libraries/hwe';
export { HelmTypes, MonomerTypes, PolymerTypes };
// hwe migration: these two small enums are not part of the hwe value vocabulary.
// They are defined here locally (replicating the legacy HELM Web Editor values)
// so `@datagrok-libraries/bio` no longer depends on
// `@datagrok-libraries/helm-web-editor`.
export var MonomerNumberingTypes;
(function (MonomerNumberingTypes) {
    MonomerNumberingTypes[MonomerNumberingTypes["default"] = 0] = "default";
    MonomerNumberingTypes[MonomerNumberingTypes["continuous"] = 1] = "continuous";
})(MonomerNumberingTypes || (MonomerNumberingTypes = {}));
export var HelmTabKeys;
(function (HelmTabKeys) {
    HelmTabKeys["Sequence"] = "sequence";
    HelmTabKeys["Helm"] = "notation";
    HelmTabKeys["Properties"] = "properties";
    HelmTabKeys["StructureView"] = "structureview";
})(HelmTabKeys || (HelmTabKeys = {}));
//# sourceMappingURL=consts.js.map